// extracted by mini-css-extract-plugin
export default {"container":"ScreenTemplate_container__GN5KC"};